// import { initializeApp } from "firebase/app";
// import { getMessaging, onMessage } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "AIzaSyBxV9cPv2uE1qBcUYIKR-9H0SbCMN1a5Fo",
//   authDomain: "yslamo-web.firebaseapp.com",
//   projectId: "yslamo-web",
//   storageBucket: "yslamo-web.firebasestorage.app",
//   messagingSenderId: "214278264982",
//   appId: "1:214278264982:web:3826272994cd5af3ca0ab7",
//   measurementId: "G-Y4VNCCNSD7"
// };

// const app = initializeApp(firebaseConfig);

// export const messaging = getMessaging(app);

// export const listenNotifications = (callback) => {
//   onMessage(messaging, (payload) => {
//     console.log("New Notification:", payload);

//     callback(payload);
//   });
// };
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBxV9cPv2uE1qBcUYIKR-9H0SbCMN1a5Fo",
  authDomain: "yslamo-web.firebaseapp.com",
  projectId: "yslamo-web",
  storageBucket: "yslamo-web.firebasestorage.app",
  messagingSenderId: "214278264982",
  appId: "1:214278264982:web:3826272994cd5af3ca0ab7",
  measurementId: "G-Y4VNCCNSD7"
};

const app = initializeApp(firebaseConfig);

let messaging = null;

export const initFirebaseMessaging = async () => {
  try {
    const supported = await isSupported();

    if (supported && typeof window !== "undefined") {
      messaging = getMessaging(app);
      console.log("✅ Firebase Messaging Enabled");
    } else {
      console.log("❌ Messaging not supported");
    }
  } catch (e) {
    console.log("Messaging error:", e);
  }
};

// 👇 دي الجديدة
export const getMessagingInstance = () => messaging;

export const listenNotifications = (callback) => {
  if (!messaging) return;

  onMessage(messaging, (payload) => {
    console.log("New Notification:", payload);
    callback(payload);
  });
};